if (!customElements.get('blog-carousel')) {
  customElements.define(
    'blog-carousel',
    class BlogCarousel extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.initAttempts = 0;
        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.stopEditorDrag = this.stopEditorDrag.bind(this);
      }

      connectedCallback() {
        this.scheduleInit();
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      reinit() {
        this.destroySlider();
        this.initAttempts = 0;
        this.scheduleInit();
      }

      scheduleInit() {
        requestAnimationFrame(() => this.init());
      }

      init() {
        if (this.slider && this.slider.el && this.contains(this.slider.el)) return;

        if (typeof window.BlazeSlider !== 'function') {
          this.retryInit();
          return;
        }

        const root = this.querySelector('.blaze-slider');
        const slides = root ? root.querySelectorAll('.blaze-track > *') : [];

        if (!root || slides.length === 0) {
          this.retryInit();
          return;
        }

        this.destroySlider();
        this.slider = new window.BlazeSlider(root, this.getConfig());
        this.currentEl = this.querySelector('.slider-counter--current');
        this.totalEl = this.querySelector('.slider-counter--total');
        this.controls = this.querySelector('[data-carousel-controls]');

        this.bindControls();
        this.updateCounter(this.slider.stateIndex);
        this.updateControlsVisibility();

        this.slider.onSlide((pageIndex) => {
          this.updateCounter(pageIndex);
        });
      }

      retryInit() {
        if (this.initAttempts >= 20) return;
        this.initAttempts += 1;
        window.setTimeout(() => this.init(), 100);
      }

      destroySlider() {
        this.unbindControls();

        if (this.slider && typeof this.slider.destroy === 'function') {
          this.slider.destroy();
        }

        this.slider = null;
      }

      bindControls() {
        this.prevBtn = this.querySelector('.blaze-prev');
        this.nextBtn = this.querySelector('.blaze-next');

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', this.onPrevClick, true);
          this.prevBtn.addEventListener('pointerdown', this.stopEditorDrag, true);
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', this.onNextClick, true);
          this.nextBtn.addEventListener('pointerdown', this.stopEditorDrag, true);
        }
      }

      unbindControls() {
        if (this.prevBtn) {
          this.prevBtn.removeEventListener('click', this.onPrevClick, true);
          this.prevBtn.removeEventListener('pointerdown', this.stopEditorDrag, true);
        }

        if (this.nextBtn) {
          this.nextBtn.removeEventListener('click', this.onNextClick, true);
          this.nextBtn.removeEventListener('pointerdown', this.stopEditorDrag, true);
        }
      }

      stopEditorDrag(event) {
        event.stopPropagation();
      }

      onPrevClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.slider) this.slider.prev();
      }

      onNextClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.slider) this.slider.next();
      }

      getConfig() {
        const fallback = {
          all: {
            slidesToShow: 3,
            slidesToScroll: 1,
            slideGap: '24px',
            loop: false,
            draggable: true,
            transitionDuration: 300,
          },
          '(max-width: 989px)': {
            slidesToShow: 2,
            slideGap: '16px',
          },
          '(max-width: 651px)': {
            slidesToShow: 1.6,
            slideGap: '16px',
          },
          '(max-width: 418px)': {
            slidesToShow: 1.4,
            slideGap: '16px',
          },
        };

        try {
          const parsed = JSON.parse(this.getAttribute('data-slider-config') || '{}');
          return Object.keys(parsed).length ? parsed : fallback;
        } catch (error) {
          return fallback;
        }
      }

      updateCounter(pageIndex) {
        if (!this.slider || !this.currentEl) return;

        const total = this.slider.totalSlides;
        const state = this.slider.states[pageIndex] || this.slider.states[this.slider.stateIndex];
        const startIndex = state ? state.page[0] : pageIndex;
        const isLastPage = this.slider.stateIndex === this.slider.states.length - 1;
        const current = isLastPage
          ? total
          : Math.min(total, Math.max(1, Math.round(startIndex + 1)));

        this.currentEl.textContent = String(current);

        if (this.totalEl) {
          this.totalEl.textContent = String(total);
        }
      }

      updateControlsVisibility() {
        if (!this.controls) return;

        const isStatic = Boolean(this.slider && this.slider.isStatic);
        this.controls.hidden = isStatic;
        this.controls.classList.toggle('blog-carousel__controls--hidden', isStatic);
      }
    }
  );
}

function reinitBlogCarousels(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('blog-carousel').forEach((carousel) => {
    if (typeof carousel.reinit === 'function') carousel.reinit();
  });
}

document.addEventListener('shopify:section:load', (event) => {
  reinitBlogCarousels(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('blog-carousel').forEach((carousel) => {
    if (typeof carousel.destroySlider === 'function') carousel.destroySlider();
  });
});

document.addEventListener('shopify:section:reorder', () => {
  reinitBlogCarousels(document);
});
